import EquipmentMaintenance from './equipment-maintenance';
import EquipmentInspection from './equipment-inspection';
import Clean from './clean';




export default {
    Clean, EquipmentMaintenance, EquipmentInspection
}